import { createSlice } from "@reduxjs/toolkit";
import { MilestoneNote } from "./MilestoneNote";
import {
  fetchMilestoneNotes,
  addMilestoneNote,
  deleteMilestoneNote,
} from "./milestoneNotesApi";
import { RootState } from "../../app/store";

interface MilestoneNotesState {
  notes: MilestoneNote[];
  status: "idle" | "loading" | "failed";
  addStatus: "idle" | "loading" | "failed";
}

const initialState: MilestoneNotesState = {
  notes: [],
  status: "idle",
  addStatus: "idle",
};

const milestoneNotesSlice = createSlice({
  name: "milestoneNotes",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMilestoneNotes.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchMilestoneNotes.fulfilled, (state, action) => {
        state.notes = action.payload;
        state.status = "idle";
      })
      .addCase(fetchMilestoneNotes.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(addMilestoneNote.pending, (state) => {
        state.addStatus = "loading";
      })
      .addCase(addMilestoneNote.fulfilled, (state, action) => {
        state.notes.unshift(action.payload);
        state.addStatus = "idle";
      })
      .addCase(addMilestoneNote.rejected, (state) => {
        state.addStatus = "failed";
      })
      .addCase(deleteMilestoneNote.fulfilled, (state, action) => {
        state.notes = state.notes.filter((n) => n.id !== action.payload);
      });
  },
});

export const selectMilestoneNotes = (state: RootState) =>
  state.milestoneNotes.notes;

export const selectMilestoneNotesLoading = (state: RootState) =>
  state.milestoneNotes.status === "loading";

export const selectMilestoneNotesAddLoading = (state: RootState) =>
  state.milestoneNotes.addStatus === "loading";

export default milestoneNotesSlice.reducer;
